import { constants } from "../constants";
import { logError } from "../errors/logger";

export const formatProductPrice = (amountObj = {}) => {
  let priceTag = { amount: "0.00", currencySymbol: constants.currency.GBP };
  if (amountObj) {
    let symbol = "";
    if (amountObj?.symbol) {
      symbol = amountObj.symbol;
    } else if (amountObj?.currency) {
      symbol = constants.currency?.[amountObj.currency];
    }

    priceTag.currencySymbol = symbol || priceTag.currencySymbol;
    try {
      let price = amountObj?.value;
      price = parseFloat(price);
      if (isNaN(price)) price = 0;
      price = Math.round(price * 100) / 100;
      priceTag.amount = price.toFixed(2);
    } catch (error) {
      logError({ error, info: { amountObj }, message: "formatProductPrice" });
      priceTag.amount = "0.00";
    }
  }
  return `${priceTag.currencySymbol}${priceTag.amount}`;
};
